import {
  UPDATE_CURRENT_PROVIDER_CONTENT,
  CURRENT_PROVIDER_CONTENT_OPEN,
  CURRENT_PROCESS_INFO_OPEN,
  CURRENT_PROVIDER_CONTENT_CLOSE,
  CURRENT_PROCESS_INFO_CLOSE
} from '../actions/types';

const initialState = {
  id: '',
  name: '',
  slug: '',
  url: '',
  description: '',
  metadata: {},
  callToAction: '',
  contents: '',
  subSections: [],
  isDrawerOpen: false,
  isOpen: false,
  index: null, 
  providerTab: 0
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case UPDATE_CURRENT_PROVIDER_CONTENT:
      return { ...state, ...action.payload };
    case CURRENT_PROVIDER_CONTENT_OPEN:
      return { ...state, isOpen: true };
    case CURRENT_PROCESS_INFO_OPEN:
      return { ...state, isDrawerOpen: true };
    case CURRENT_PROVIDER_CONTENT_CLOSE:
      return { ...state, isOpen: false };
    case CURRENT_PROCESS_INFO_CLOSE:
      return { ...state, isDrawerOpen: false };
    default:
      return state;
  }
};
